import React from 'react'
import { PictureArea } from './style'
import { hasNewCardLayout } from '@/utils/utils'

export default ({ children, isHorizontal }) => {
  const hasNewCardTestAB = hasNewCardLayout()

  const cardVerticalDimensions = hasNewCardTestAB
    ? { width: '300px', height: '232px' }
    : { width: '242px', height: '172px' }
  const cardHorizontalDimensions = { width: '249px', height: 'auto' }

  const { width, height } = isHorizontal
    ? cardHorizontalDimensions
    : cardVerticalDimensions

  return (
    <PictureArea width={width} height={height}>
      {children}
    </PictureArea>
  )
}
